import * as Scrivito from "scrivito";
import metadataAttributes from "../_metadataAttributes";
import defaultPageAttributes from "../_defaultPageAttributes";

const EventOverviewPage = Scrivito.provideObjClass("EventOverviewPage", {
  attributes: {
    ...defaultPageAttributes,
    recommendedEvents: ["referencelist", { only: "EventPage" }],
    body: ["widgetlist", { only: "SectionWidget" }],
    navigationIcon: "string",
    ...metadataAttributes,
  },
  extractTextAttributes: ["body", "title", "segmentName", "description"],
});

export default EventOverviewPage;
